"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var Button_1 = __importDefault(require("./Button"));
var muiThemeable_1 = __importDefault(require("material-ui/styles/muiThemeable"));
var close_1 = __importDefault(require("material-ui/svg-icons/navigation/close"));
var check_1 = __importDefault(require("material-ui/svg-icons/navigation/check"));
var wrapperStyle = {
    display: 'inline-block',
    minWidth: 88,
};
var inlineStyle = {
    minWidth: 44,
};
var ConfirmButton = function (_a) {
    var style = _a.style, className = _a.className, confirm = _a.confirm, label = _a.label, onClick = _a.onClick, onClose = _a.onClose, onConfirm = _a.onConfirm, muiTheme = _a.muiTheme, rest = __rest(_a, ["style", "className", "confirm", "label", "onClick", "onClose", "onConfirm", "muiTheme"]);
    if (confirm) {
        var backgroundColor = lodash_1.get(muiTheme, 'confirmButton.backgroundColor', false);
        return (react_1.default.createElement("div", { style: __assign({}, style, wrapperStyle), className: className },
            react_1.default.createElement(Button_1.default, { primary: !backgroundColor, backgroundColor: backgroundColor, onClick: onConfirm, style: __assign({}, inlineStyle, { marginRight: 5 }), icon: react_1.default.createElement(check_1.default, null) }),
            react_1.default.createElement(Button_1.default, { secondary: true, onClick: onClose, style: inlineStyle, icon: react_1.default.createElement(close_1.default, null) })));
    }
    else {
        return react_1.default.createElement(Button_1.default, __assign({ style: style, className: className, label: label, onClick: onClick }, rest));
    }
};
exports.default = recompose_1.compose(muiThemeable_1.default(), recompose_1.defaultProps({ onClick: lodash_1.noop }), recompose_1.withState('confirm', 'setConfirm', false), recompose_1.withHandlers({
    onClick: function (_a) {
        var setConfirm = _a.setConfirm;
        return function () { return setConfirm(true); };
    },
    onClose: function (_a) {
        var setConfirm = _a.setConfirm;
        return function () { return setConfirm(false); };
    },
    onConfirm: function (_a) {
        var onClick = _a.onClick, setConfirm = _a.setConfirm;
        return function () {
            onClick();
            setConfirm(false);
        };
    },
}), recompose_1.mapProps(function (_a) {
    var setConfirm = _a.setConfirm, rest = __rest(_a, ["setConfirm"]);
    return (__assign({}, rest));
}))(ConfirmButton);
//# sourceMappingURL=ConfirmButton.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/ConfirmButton.js
// module id = 369
// module chunks = 0